import { c as _c } from "react/compiler-runtime";
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { flagsContext } from '@/contexts/flagsContext';
import { useEnvironment } from '@/contexts/useEnvironment';
import { parseJson } from '@/utils/string';
export const useFeatureFlags = () => {
  const $ = _c(6);
  const conductedFlags = useFlags(flagsContext);
  let t0;
  let t1;
  if ($[0] !== conductedFlags) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const flagsOverrides = typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get("flags");
      if (!flagsOverrides) {
        t1 = conductedFlags;
        break bb0;
      }
      t0 = flagsOverrides.split(",").reduce(_temp, {});
    }
    $[0] = conductedFlags;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  const flags = t0;
  let t2;
  if ($[3] !== conductedFlags || $[4] !== flags) {
    t2 = {
      ...conductedFlags,
      ...flags
    };
    $[3] = conductedFlags;
    $[4] = flags;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useLaunchDarkly = () => {
  const $ = _c(5);
  const {
    isDemo,
    isDev,
    isTest
  } = useEnvironment();
  const [ldClientReady, setLDClientReady] = useState(isDemo || isDev || isTest);
  const ldClient = useLDClient(flagsContext);
  let t0;
  let t1;
  if ($[0] !== ldClient) {
    t0 = () => {
      ldClient?.waitUntilReady().then(() => setLDClientReady(true));
    };
    t1 = [ldClient];
    $[0] = ldClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== ldClientReady) {
    t2 = {
      isReady: ldClientReady
    };
    $[3] = ldClientReady;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(acc, flag) {
  const parts = flag.split(":");
  const [key, value] = parts;
  if (parts.length === 1) {
    return {
      ...acc,
      [key]: true
    };
  }
  const parsedValue = parseJson(value);
  return {
    ...acc,
    [key]: parsedValue === undefined ? value : parsedValue
  };
}